var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg044Coverall = function Svg044Coverall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 422h90V301h30v121h83.817L338.84 241H150zM180 0v105c0 8.276-6.724 15-15 15h-15v91h186.343L330 133.755V0h-30v60h-90V0zM150 452h90v60h-90zM270 452v60h92l-5.688-60z"
  })));
};
export default Svg044Coverall;